import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/Loader";
import { Badge } from "../../../Components/Badge";
import { GroupService } from "../../../DataService/GroupService";
import { SeminarService } from "../../../DataService/SeminarService";
import { GroupDto } from "../../../Types/GroupServiceTypes";
import { CreateSeminarDto } from "../../../Types/SeminarServiceTypes";
import { Icon } from "../../../Icons/Icon";
import { Button } from "../../../Components/Button";
import '../AdminGroups.css'
const SendSeminarInvitesPage: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
const seminarId = params.get("id");
  const [groups, setGroups] = useState<GroupDto[]>([]);
  const [loadingGroups, setLoadingGroups] = useState(true);
  const [isSending, setIsSending] = useState(false);

  const [seminar, setSeminar] = useState<CreateSeminarDto>({
    title: "",
    description: "",
    date: "",
    time: "",
    link: "",
    selectedGroups: []
  });
  const selectedGroupCount = seminar.selectedGroups.length;

  const navigate = useNavigate();

 const loadSeminar = useCallback(async () => {
   if (!seminarId) return;

   const s = await SeminarService.GetSeminarById(seminarId);
   if (!s) return;

   setSeminar({
     title: s.title,
     description: s.description ?? "",
     date: s.date ?? "",
     time: s.time ?? "",
     link: s.link ?? "",
     selectedGroups: s.groups.map(g => g.groupId)
   });
 }, [seminarId]);

  const loadGroups = useCallback(async () => {
    setLoadingGroups(true);
    const g = await GroupService.GetGroups();
    if (g) setGroups(g);
    setLoadingGroups(false);
  }, []);

 useEffect(() => {
   void loadSeminar();
   void loadGroups();
 }, [loadGroups, loadSeminar]);

  // const handleSend = async () => {
  //   if (!seminar.title || !seminar.link || seminar.selectedGroups.length === 0) {
  //     toast.warning("Fyll i alla obligatoriska fält");
  //     return;
  //   }

  //   setIsSending(true);
  //   const created = await SeminarService.CreateSeminar(seminar);
  //   if (!created) {
  //     setIsSending(false);
  //     return;
  //   }

  //   const ok = await SeminarService.SendSeminarInvites(created.id);
  //   if (ok) {
  //     toast.success("Inbjudningar skickade!");
  //     navigate("/admin-seminars");
  //   }
  //   setIsSending(false);
  // };
  const handleSend = async () => {
    setIsSending(true);
  if (!seminarId) {
      toast.error("Seminarium saknar ID");
      return;
  }

  const ok = await SeminarService.SendSeminarInvites(seminarId);

  if (ok) {
      toast.success("Inbjudningar skickade!");
      navigate("/admin/seminars");
  }
  setIsSending(false);
};

  return (
    <div className="admin-page-shell admin-groups-page-shell">
      <div className="admin-groups-container-margin">
        <div className="admin-groups-title-container">
            <button onClick={() => navigate("/admin/seminars")} className="admin-courses-home-link" style={{ background: "none", border: "none" }}>
            <Icon.ArrowLeft /> Tillbaka
          </button>
          <h1 className="admin-groups-title-text">Skicka seminarieinbjudningar</h1>
          <p className="admin-groups-title-paragraph">Skapa seminarium och skicka inbjudningar till valda grupper</p>
        </div>

        <div className="admin-groups-overview-grid">
          <div className="admin-groups-overview-card">
            <span>Valda grupper</span>
            <strong>{selectedGroupCount}</strong>
            <p>Seminariet skickas bara när minst en grupp är markerad.</p>
          </div>
          <div className="admin-groups-overview-card">
            <span>Fältstatus</span>
            <Badge variant={seminar.title && seminar.link && selectedGroupCount > 0 ? 'default' : 'secondary'}>
              {seminar.title && seminar.link && selectedGroupCount > 0 ? 'Redo att skicka' : 'Pågår'}
            </Badge>
            <p>Tydlig status innan inbjudan går iväg.</p>
          </div>
        </div>

        <div className="admin-surface-card admin-groups-split-card" style={{ marginTop: 16 }}>
          <div className="admin-group-modal-form admin-groups-split-form">
            <label className="block-text-sm-font-medium-text-gray-700-mb-1">Seminartitel *</label>
            <input className="admingroups-input" value={seminar.title} onChange={(e) => setSeminar(prev => ({ ...prev, title: e.target.value }))} />
            <label className="block-text-sm-font-medium-text-gray-700-mb-1">Länk *</label>
            <input className="admingroups-input" value={seminar.link} onChange={(e) => setSeminar(prev => ({ ...prev, link: e.target.value }))} />
            <label className="block-text-sm-font-medium-text-gray-700-mb-1">Datum</label>
            <input className="admingroups-schedule--time-input" type="date" value={seminar.date} onChange={(e) => setSeminar(prev => ({ ...prev, date: e.target.value }))} />
            <label className="block-text-sm-font-medium-text-gray-700-mb-1">Tid</label>
            <input className="admingroups-schedule--time-input" type="time" value={seminar.time} onChange={(e) => setSeminar(prev => ({ ...prev, time: e.target.value }))} />
            <label className="block-text-sm-font-medium-text-gray-700-mb-2">Välj grupper att bjuda in *</label>

            {loadingGroups ? (
              <div style={{ display: "flex", justifyContent: "center", paddingTop: 12 }}>
                <Loader loaderSize="MEDIUM" bgColor="hsl(var(--primary))" />
              </div>
            ) : (
              <div className="admin-group-modal-recipient-list admin-groups-checkbox-list">
                {groups.map(g => (
                  <label key={g.id} className="flex-items-center-space-x-3">
                    <input type="checkbox" checked={seminar.selectedGroups.includes(g.id)} onChange={(e) => {
                      if (e.target.checked) setSeminar(prev => ({ ...prev, selectedGroups: [...prev.selectedGroups, g.id] }));
                      else setSeminar(prev => ({ ...prev, selectedGroups: prev.selectedGroups.filter(id => id !== g.id) }));
                    }} className="rounded-border-gray-300-text-e16a54-focus-ring-e16a54" />
                    <span className="text-sm">{g.name} ({g.users.length} medlemmar)</span>
                  </label>
                ))}
              </div>
            )}

            <div className="admin-group-modal-footer" style={{ marginTop: 12 }}>
              <Button className="submit-button" onClick={handleSend} text={isSending ? <><Loader loaderSize="XSMALL" bgColor="white" /> Skickar...</> : <>Skapa & Skicka inbjudningar</>} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendSeminarInvitesPage;
